/* ═══════════════════════════════════════════════════
   Planteka Workshop Collection — JavaScript (v5)
   No modal — cards and calendar items link to product pages
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  const root = document.getElementById('planteka-workshops');
  if (!root) return;

  const $ = (sel, ctx) => (ctx || root).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || root).querySelectorAll(sel)];

  // ── Locale ─────────────────────────────────────
  const locale = root.dataset.locale || 'es';
  const isEN = locale.startsWith('en');

  const MONTHS = isEN
    ? ['January','February','March','April','May','June','July','August','September','October','November','December']
    : ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

  const WEEKDAYS_SHORT = isEN
    ? ['Mon','Tue','Wed','Thu','Fri','Sat','Sun']
    : ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];

  const i18n = isEN ? {
    workshops: 'workshops', workshop: 'workshop',
    active: 'Active:', selectDate: 'Select a date',
    selectDateHint: 'Click a highlighted date to see workshops',
    noMatch: 'No workshops on this date with current filters',
    available: 'Available', today: 'Today', selected: 'Selected',
    soldOut: 'Sold out', readMore: 'Read more ↓', readLess: 'Show less ↑',
  } : {
    workshops: 'talleres', workshop: 'taller',
    active: 'Activos:', selectDate: 'Selecciona una fecha',
    selectDateHint: 'Haz clic en una fecha destacada para ver los talleres',
    noMatch: 'No hay talleres en esta fecha con los filtros activos',
    available: 'Disponible', today: 'Hoy', selected: 'Seleccionado',
    soldOut: 'Agotado', readMore: 'Leer más ↓', readLess: 'Leer menos ↑',
  };

  // Apply i18n
  $$('[data-i18n]').forEach((el) => { const k = el.dataset.i18n; if (i18n[k]) el.textContent = i18n[k]; });
  const weekdaysEl = $('[data-cal-weekdays]');
  if (weekdaysEl) weekdaysEl.innerHTML = WEEKDAYS_SHORT.map((d) => `<span>${d}</span>`).join('');

  // ── Elements ───────────────────────────────────
  const searchInput = $('[data-search-input]');
  const filterBtn = $('[data-toggle-filters]');
  const filtersPanel = $('[data-filters-panel]');
  const filterCountBadge = $('[data-filter-count]');
  const activeFiltersBar = $('[data-active-filters]');
  const clearBtns = $$('[data-clear-filters]');
  const viewBtns = $$('[data-view]');
  const gridView = $('[data-view-grid]');
  const calendarView = $('[data-view-calendar]');
  const workshopCards = $$('[data-workshop]');
  const emptyState = $('[data-empty-state]');
  const countEl = $('[data-workshop-count]');
  const calGrid = $('[data-cal-grid]');
  const calLabel = $('[data-cal-label]');
  const calPrev = $('[data-cal-prev]');
  const calNext = $('[data-cal-next]');
  const calResults = $('[data-cal-results]');

  // ── State ──────────────────────────────────────
  const today = root.dataset.today;
  let calMonth = parseInt(root.dataset.month) - 1;
  let calYear = parseInt(root.dataset.year);
  let selectedDate = null;
  let currentView = 'grid';
  const filters = { category: new Set(), city: new Set(), neighbourhood: new Set(), provider: new Set(), price: null };

  // ── Parse variant dates ────────────────────────
  function parseVariantDates(rawStr) {
    if (!rawStr) return [];
    const parts = rawStr.split('|||').filter(Boolean);
    const results = [], seen = new Set();
    for (const part of parts) {
      let str = part.trim(), soldOut = false;
      if (str.startsWith('[X]')) { soldOut = true; str = str.substring(3); }
      const m = str.match(/(\d{2})\.(\d{2})\.(\d{4})/);
      if (!m) continue;
      const iso = `${m[3]}-${m[2]}-${m[1]}`;
      if (seen.has(iso)) { if (!soldOut) { const ex = results.find((r) => r.date === iso); if (ex) ex.soldOut = false; } continue; }
      seen.add(iso);
      let time = '';
      const pi = str.indexOf('|');
      if (pi !== -1) { const tm = str.substring(pi + 1).trim().match(/(\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2})/); if (tm) time = tm[1].trim(); }
      results.push({ date: iso, time, soldOut });
    }
    results.sort((a, b) => a.date.localeCompare(b.date));
    return results;
  }

  // ── Parse workshops ────────────────────────────
  const workshops = workshopCards.map((el) => {
    const ve = parseVariantDates(el.dataset.variantDates || '');
    const dtm = {}, dso = {};
    ve.forEach((e) => { dtm[e.date] = e.time; dso[e.date] = e.soldOut; });
    return {
      el, variantEntries: ve, dates: ve.map((e) => e.date), dateTimeMap: dtm, dateSoldOutMap: dso,
      title: (el.dataset.title || '').toLowerCase(),
      category: el.dataset.category || '',
      city: el.dataset.city || '',
      neighbourhood: el.dataset.neighbourhood || '',
      provider: el.dataset.provider || '',
      price: parseInt(el.dataset.price || '0', 10),
      description: el.dataset.description || '',
      url: el.href || '#',
    };
  });

  // ── Helpers ────────────────────────────────────
  function fmtDatePretty(str) { return new Date(str + 'T00:00:00').toLocaleDateString(isEN ? 'en-GB' : 'es-ES', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function fmtEUR(c) { return new Intl.NumberFormat(isEN ? 'en-IE' : 'es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(c / 100); }
  function getCalDays(y, m) { const f = new Date(y, m, 1), l = new Date(y, m + 1, 0); let s = f.getDay() - 1; if (s < 0) s = 6; const d = []; for (let i = 0; i < s; i++) d.push(null); for (let i = 1; i <= l.getDate(); i++) d.push(i); return d; }
  function pad(n) { return String(n).padStart(2, '0'); }
  function fmtD(y, m, d) { return `${y}-${pad(m + 1)}-${pad(d)}`; }

  // Next date on cards — show "Next: date" + hint for more
  const nextLabel = isEN ? 'Next' : 'Próx';
  const moreDates = isEN ? '+ more dates' : '+ más fechas';

  workshops.forEach((w) => {
    const el = w.el.querySelector('[data-next-date]');
    if (!el) return;
    const futureDates = w.variantEntries.filter((e) => e.date >= today);
    const availableDates = futureDates.filter((e) => !e.soldOut);
    const next = availableDates[0] || futureDates[0];
    if (!next) return;

    let text = nextLabel + ': ' + fmtDatePretty(next.date);
    const totalFuture = availableDates.length || futureDates.length;
    if (totalFuture > 1) text += ` (${moreDates})`;

    if (!availableDates.length && futureDates.length) {
      text = fmtDatePretty(next.date) + ` (${i18n.soldOut})`;
      el.style.color = 'var(--pw-text-muted)';
    }
    el.textContent = text;
  });

  // ── Filtering ──────────────────────────────────
  function matchNoDate(w) {
    const q = (searchInput.value || '').toLowerCase().trim();
    if (q) { const h = w.title + ' ' + w.category.toLowerCase() + ' ' + w.city.toLowerCase() + ' ' + w.provider.toLowerCase() + ' ' + w.description.toLowerCase() + ' ' + w.neighbourhood.toLowerCase(); if (!h.includes(q)) return false; }
    if (filters.category.size > 0 && !filters.category.has(w.category)) return false;
    if (filters.city.size > 0 && !filters.city.has(w.city)) return false;
    if (filters.neighbourhood.size > 0 && !filters.neighbourhood.has(w.neighbourhood)) return false;
    if (filters.provider.size > 0 && !filters.provider.has(w.provider)) return false;
    if (filters.price) { const p = w.price / 100; if (p < filters.price.min || p > filters.price.max) return false; }
    return true;
  }
  function applyFilters() {
    let n = 0;
    workshops.forEach((w) => { let s = matchNoDate(w); if (s && selectedDate && !w.dates.includes(selectedDate)) s = false; w.el.hidden = !s; w._visible = s; if (s) n++; });
    emptyState.style.display = n === 0 ? '' : 'none';
    if (countEl) countEl.textContent = `${n} ${n !== 1 ? i18n.workshops : i18n.workshop}`;
    if (currentView === 'calendar') { renderCal(); renderCalResults(); }
  }
  function getFC() { return filters.category.size + filters.city.size + filters.neighbourhood.size + filters.provider.size + (filters.price ? 1 : 0) + (selectedDate ? 1 : 0); }
  function updateFUI() {
    const c = getFC();
    filterCountBadge.textContent = c; filterCountBadge.style.display = c > 0 ? '' : 'none';
    filterBtn.classList.toggle('has-active', c > 0);
    if (c > 0 && filtersPanel.style.display === 'none') {
      activeFiltersBar.style.display = '';
      let h = `<span style="font-size:12px;color:var(--pw-text-muted);margin-right:4px">${i18n.active}</span>`;
      ['category','city','neighbourhood','provider'].forEach((k) => { filters[k].forEach((v) => { h += `<button class="pw-active-pill" data-remove-filter="${k}" data-remove-value="${v}">${v} ✕</button>`; }); });
      if (filters.price) h += `<button class="pw-active-pill" data-remove-filter="price">${filters.price.label} ✕</button>`;
      if (selectedDate) h += `<button class="pw-active-pill" data-remove-filter="date">${fmtDatePretty(selectedDate)} ✕</button>`;
      activeFiltersBar.innerHTML = h;
    } else { activeFiltersBar.style.display = 'none'; }
    $$('.pw-chip', filtersPanel).forEach((c) => { const t = c.dataset.filter, v = c.dataset.value; let a = false;
      if (t === 'price') { if (filters.price) { const [mn, mx] = v.split('-').map(Number); a = filters.price.min === mn && filters.price.max === mx; } }
      else { a = filters[t] && filters[t].has(v); } c.classList.toggle('is-active', a); });
  }
  function clearAll() { filters.category.clear(); filters.city.clear(); filters.neighbourhood.clear(); filters.provider.clear(); filters.price = null; selectedDate = null; searchInput.value = ''; updateFUI(); applyFilters(); }

  // ── Events ─────────────────────────────────────
  filtersPanel.addEventListener('click', (e) => { const c = e.target.closest('.pw-chip'); if (!c) return; const t = c.dataset.filter, v = c.dataset.value;
    if (t === 'price') { const [mn, mx] = v.split('-').map(Number); if (filters.price && filters.price.min === mn && filters.price.max === mx) filters.price = null; else filters.price = { min: mn, max: mx, label: c.textContent.trim() }; }
    else { if (filters[t].has(v)) filters[t].delete(v); else filters[t].add(v); } updateFUI(); applyFilters(); });
  activeFiltersBar.addEventListener('click', (e) => { const p = e.target.closest('[data-remove-filter]'); if (!p) return; const t = p.dataset.removeFilter;
    if (t === 'price') filters.price = null; else if (t === 'date') selectedDate = null; else filters[t].delete(p.dataset.removeValue); updateFUI(); applyFilters(); });
  filtersPanel.addEventListener('click', (e) => { const t = e.target.closest('[data-filter-toggle]'); if (t) t.closest('.pw-filter-group').classList.toggle('is-collapsed'); });
  filterBtn.addEventListener('click', () => { const o = filtersPanel.style.display === 'none'; filtersPanel.style.display = o ? '' : 'none'; if (o) activeFiltersBar.style.display = 'none'; else updateFUI(); });
  clearBtns.forEach((b) => b.addEventListener('click', clearAll));
  let st; searchInput.addEventListener('input', () => { clearTimeout(st); st = setTimeout(applyFilters, 200); });
  viewBtns.forEach((b) => { b.addEventListener('click', () => { currentView = b.dataset.view; viewBtns.forEach((x) => x.classList.toggle('is-active', x === b));
    gridView.style.display = currentView === 'grid' ? '' : 'none'; calendarView.style.display = currentView === 'calendar' ? '' : 'none';
    if (currentView === 'calendar') { renderCal(); renderCalResults(); } }); });

  // ── Calendar ───────────────────────────────────
  const comingSoon = isEN
    ? 'New dates for this month will be published soon. Check back later!'
    : 'Las nuevas fechas para este mes se publicarán pronto. ¡Vuelve a consultar!';
  const comingSoonTitle = isEN ? 'Dates coming soon' : 'Fechas próximamente';

  function renderCal() {
    const ds = new Set(); workshops.forEach((w) => { if (matchNoDate(w)) w.dates.forEach((d) => ds.add(d)); });
    calLabel.textContent = `${MONTHS[calMonth]} ${calYear}`;
    const days = getCalDays(calYear, calMonth); let h = '';
    let monthHasDates = false;
    days.forEach((d) => { if (d === null) { h += '<button class="pw-cal-day pw-cal-day--empty" disabled></button>'; return; }
      const s = fmtD(calYear, calMonth, d), hw = ds.has(s), it = s === today, ip = s < today, is_ = s === selectedDate;
      if (hw) monthHasDates = true;
      let cl = 'pw-cal-day'; if (ip) cl += ' pw-cal-day--past'; if (it) cl += ' pw-cal-day--today'; if (hw) cl += ' pw-cal-day--has-workshop'; if (is_) cl += ' pw-cal-day--selected';
      h += `<button class="${cl}" ${hw ? `data-cal-date="${s}"` : 'disabled'}>${d}${hw && !is_ ? '<span class="pw-cal-dot"></span>' : ''}</button>`; });
    calGrid.innerHTML = h;

    // Show "coming soon" if this month is in the future and has no dates
    const calComingSoon = calGrid.parentElement.querySelector('[data-cal-coming-soon]');
    if (calComingSoon) calComingSoon.remove();
    const viewedMonth = new Date(calYear, calMonth + 1, 0); // last day of viewed month
    const todayDate = new Date(today + 'T00:00:00');
    if (!monthHasDates && viewedMonth >= todayDate) {
      const msg = document.createElement('div');
      msg.setAttribute('data-cal-coming-soon', '');
      msg.className = 'pw-cal-coming-soon';
      msg.innerHTML = `<span class="pw-cal-coming-soon__icon">🌱</span><strong>${comingSoonTitle}</strong><p>${comingSoon}</p>`;
      calGrid.parentElement.appendChild(msg);
    }
  }
  calGrid.addEventListener('click', (e) => { const b = e.target.closest('[data-cal-date]'); if (!b) return; selectedDate = selectedDate === b.dataset.calDate ? null : b.dataset.calDate; updateFUI(); applyFilters(); });
  calPrev.addEventListener('click', () => { calMonth--; if (calMonth < 0) { calMonth = 11; calYear--; } renderCal(); });
  calNext.addEventListener('click', () => { calMonth++; if (calMonth > 11) { calMonth = 0; calYear++; } renderCal(); });

  function renderCalResults() {
    if (!selectedDate) { calResults.innerHTML = `<div class="pw-calendar-placeholder"><div class="pw-calendar-placeholder__icon">📅</div><h3>${i18n.selectDate}</h3><p>${i18n.selectDateHint}</p></div>`; return; }
    const ms = workshops.filter((w) => w._visible && w.dates.includes(selectedDate));
    let h = `<h2 class="pw-cal-date-title">${fmtDatePretty(selectedDate)}<span class="pw-cal-date-count">${ms.length} ${ms.length !== 1 ? i18n.workshops : i18n.workshop}</span></h2>`;
    if (ms.length === 0) { h += `<div class="pw-calendar-placeholder"><div class="pw-calendar-placeholder__icon">🍃</div><p>${i18n.noMatch}</p></div>`; }
    else { ms.forEach((w) => {
      const img = w.el.querySelector('.pw-card__image img'), src = img ? img.src : '';
      const time = w.dateTimeMap[selectedDate] || '', sold = w.dateSoldOutMap[selectedDate];
      h += `<a href="${w.url}" class="pw-cal-card${sold ? ' pw-cal-card--sold-out' : ''}">
        <div class="pw-cal-card__thumb">${src ? `<img src="${src}" alt="" loading="lazy">` : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:24px">🌿</div>'}</div>
        <div class="pw-cal-card__info"><div class="pw-cal-card__top"><div><h3 class="pw-cal-card__title">${w.el.dataset.title}</h3>
        <div class="pw-cal-card__meta">${time ? time + ' · ' : ''}${w.provider}</div></div>
        <span class="pw-cal-card__price">${fmtEUR(w.price)}</span></div>
        <div class="pw-cal-card__bottom"><span>📍 ${w.city}</span>${sold ? `<span style="color:var(--pw-danger);font-weight:600">${i18n.soldOut}</span>` : ''}</div></div></a>`; }); }
    calResults.innerHTML = h;
  }

  // ── Read more ──────────────────────────────────
  const rmBtn = document.querySelector('[data-read-more-toggle]');
  const hdesc = document.querySelector('[data-header-desc]');
  if (rmBtn && hdesc) {
    rmBtn.addEventListener('click', () => {
      const willExpand = hdesc.classList.contains('is-truncated');
      hdesc.classList.toggle('is-truncated', !willExpand);
      rmBtn.textContent = willExpand ? i18n.readLess : i18n.readMore;
    });
  }

  // ── Init ───────────────────────────────────────
  applyFilters();
})();
